<template>
	<div
		class="d-flex flex-column justify-center align-center"
		style="background-color:#d2d6de;background-size:cover;background-attachment:fixed;min-height:100vh;display:flex;flex-direction:column;"
	>
		<v-form ref="form" v-model="valid" @submit.prevent="initiateForgotPassword()">
			<v-card width="360">
				<v-card-title
					class="title d-flex justify-center align-center mb-4"
					style="background-color:#003366;color:white;"
				>
					<v-img max-width="150" :src="baseLocation + '/resource/image/v-unite-logo.png'"></v-img>
				</v-card-title>
				<v-card-text  v-if="!isSuccess">
					<v-radio-group
						v-model="tenantId"
						:rules="[v => !!v || 'Item is required']"
						v-if="tenantStaffList.length > 1"
					>
						<v-radio
							v-for="(tenant, idxTenant) in tenantStaffList"
							:key="idxTenant"
							:value="tenant.id"
							:label="tenant.name"
						>
						</v-radio>
					</v-radio-group>
					<v-text-field v-model="email" :rules="emailRules" label="E-mail" :disabled="isEmailDisable" required></v-text-field>
					<v-row class="text-right" style="margin: 0" justify="end">
						<v-col cols="8" sm="8">
							<v-btn
								depressed
								tile
								:to="'/tenant'">Cancel</v-btn>
						</v-col>
						<v-col cols="4" sm="4">
							<v-btn  :disabled="!valid" type="submit" color="primary darken-1" depressed tile>Submit</v-btn>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-text v-else class="text-center">
					<h2 class="display-1">Reset password email has been sent</h2>
					<br />
					<p>
						Please check your email, follow the link
						and change your password.
					</p>
					<v-btn
						color="primary darken-1"
						depressed
						tile
						:to="'/tenant'"
					>Back to login</v-btn>
				</v-card-text>
			</v-card>
		</v-form>
	</div>
</template>

<script>
import axios from "axios";

export default {
	data() {
		return {
			valid: true,
			email: null,
			emailRules: [
				v => !!v || "E-mail is required",
				v => /.+@.+\..+/.test(v) || "E-mail must be valid"
			],
			isSuccess: false,
			baseLocation: axios.defaults.baseURL,
			tenantStaffList: [],
			tenantId: null,
			isEmailDisable: false
		};
	},
	methods: {
		forgotPassword() {
			axios
				.post("/system/authentication/tenant/resetpassword/initiate", {
					email: this.email,
					tenantId: this.tenantId,
				})
				.then(response => {
					this.isSuccess = response.data;
					this.$refs.form.reset();
					this.isSuccess = true;
				})
				.catch(() => {});
		},
		initiateForgotPassword() {
			if (this.tenantId == null) {
				axios
					.get("/system/authentication/tenant/list?email=" + this.email)
					.then((response) => {
						this.tenantStaffList = response.data;
						if (this.tenantStaffList.length > 1) {
							this.$refs.form.resetValidation();
							this.isEmailDisable = true;
							this.valid = false;
						} else if (this.tenantStaffList.length == 1) {
							this.tenantId = this.tenantStaffList[0].id;
							this.forgotPassword();
						}
					})
					.catch(() => {});
			} else {
				this.forgotPassword();
			}
		},
	}
};
</script>